<template>
  <div v-if="isActive" class="tab-pane">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, defineProps } from 'vue';

const props = defineProps<{
  name: string;
  label: string;
}>();

const activeTab = inject<Ref<string>>('activeTab');
const setActiveTab = inject<(tabName: string) => void>('setActiveTab');

const isActive = computed(() => activeTab?.value === props.name);

if (activeTab && !activeTab.value) {
  setActiveTab?.(props.name);
}
</script>

<style scoped>
.tab-pane {
  display: none;
}

.tab-pane.active {
  display: block;
}
</style>
